import cn from 'classnames';
import { type InputHTMLAttributes, type ReactNode, useId } from 'react';

import './radio-card.scss';

type RadioCardProps = Readonly<{
    id?: string;
    value: string;
    title: ReactNode;
    checked?: boolean;
    disabled?: boolean;
    className?: string;
    inputProps?: Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'id' | 'value' | 'checked'>;
    iconSlot?: ReactNode;
}>;

export const RadioCard = ({ id, title, value, checked, disabled, inputProps, className, iconSlot }: RadioCardProps) => {
    const generatedId = useId();
    const inputId = id ?? generatedId;

    return (
        <label
            className={cn(
                'radio-card',
                { 'radio-card--checked': checked, 'radio-card--disabled': disabled },
                className
            )}
            htmlFor={inputId}
        >
            <div className="radio-card__title-container">
                <div className="radio-card__title-text">{title}</div>
                {iconSlot && <div className="radio-card__title-icon">{iconSlot}</div>}
            </div>
            <input
                id={inputId}
                type="radio"
                value={value}
                checked={checked}
                {...inputProps}
                className="radio-card__input"
            />
        </label>
    );
};
